import { IVScrollItem } from '@/modules/virtual-scroll/types';

export const getItemIndices = (items: IVScrollItem[], dataKey: string = 'id') => {
  return items.reduce((acc: Record<number | string, number>, current, index) => {
    const itemId = current[dataKey];
    acc[itemId] = index;
    return acc;
  }, {});
};
